import { Map, fromJS } from 'immutable';

const initialState = {
    forecasting: Map(),
    reorderPoint: fromJS({selectState: false})
};

export default initialState;
